export const APP_VERSION_STORAGE_KEY = "appVersion";
const APP_VERSION_META = 'meta[name="app-version"]';

export function getCurrentVersion() {
  return (process.env.VUE_APP_VOYADO_VERSION || "").trim();
}

function getStoredVersion() {
  try {
    return window.localStorage.getItem(APP_VERSION_STORAGE_KEY);
  } catch (e) {
    return null;
  }
}

export function saveVersion(version) {
  if (!version) return;
  try {
    window.localStorage.setItem(APP_VERSION_STORAGE_KEY, version);
  } catch (e) {
    // storage unavailable; nothing to persist
  }
}

// Every page load saves its own version, so a different stored value means another tab loaded a different build
export function isStoredVersionDifferent(current) {
  const stored = getStoredVersion();
  return !!current && stored !== null && stored !== current;
}

// Evaluated once at module load, before App.vue saves this build's version
export const isNewBuildLoad = (() => {
  const current = getCurrentVersion();
  return !!current && getStoredVersion() !== current;
})();

// Reads the version from index.html, which the deploy pipeline invalidates on CloudFront
export async function fetchDeployedVersion() {
  try {
    const url = `${process.env.BASE_URL || "/"}?t=${Date.now()}`;
    const response = await fetch(url, { cache: "no-store" });
    if (!response.ok) return "";
    const html = await response.text();
    const meta = new DOMParser().parseFromString(html, "text/html").querySelector(APP_VERSION_META);
    const version = ((meta && meta.getAttribute("content")) || "").trim();
    return version.length <= 64 ? version : "";
  } catch (e) {
    return "";
  }
}
